import { useQuery } from "@tanstack/react-query";
import { ApiError, api, unwrap, type Schemas } from "./api/client";

export const ME_KEY = ["me"] as const;

/** The signed-in user, or null when there is no session. */
export function useMe() {
  return useQuery<Schemas["Me"] | null>({
    queryKey: ME_KEY,
    queryFn: async () => {
      try {
        return await unwrap(api.GET("/api/auth/me"));
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 60_000,
  });
}
